
    // Import decoupled architecture core classes and drag utility classes
    import { LiquidGlassCore } from './src/core';
    import { LiquidGlassDraggable } from './src/draggable';

    // Global variables
    window.liquidGlassInstances = [];
    window.draggableInstances = [];

    // Feature functions
    window.createBasic = function () {
      clearAll();
      const glass = new LiquidGlassCore({
        position: { x: window.innerWidth / 2 - 150, y: window.innerHeight / 2 - 100 },
      });
      glass.init();
      glass.appendTo(document.body);
      console.log("glass.container", glass.container);
      const content = document.createElement('div');
      content.innerHTML = 'Hello, world!';
      content.style.position = 'absolute';
      content.style.top = '50%';
      content.style.left = '50%';
      content.style.transform = 'translate(-50%, -50%)';
      content.style.color = 'white';
      content.style.fontSize = '24px';
      content.style.fontWeight = 'bold';
      content.style.textAlign = 'center';
      content.style.zIndex = '10000';
      content.style.pointerEvents = 'none';
      // 文字加阴影
      content.style.textShadow = '0 0 10px rgba(0, 0, 0, 0.5)';
      glass.container.appendChild(content);

      // Add dragging functionality
      const draggable = new LiquidGlassDraggable(glass, {
        constrainToViewport: true,
        onDragStart: (position) => {
          console.log('Drag started:', position);
          // 保持原始样式，不添加任何视觉效果
        },
        onDrag: (position) => {
          // 保持原始样式，不修改任何效果
        },
        onDragEnd: (position) => {
          console.log('Drag ended:', position);
          // 保持原始样式，不修改任何效果
        }
      });

      window.liquidGlassInstances.push(glass);
      window.draggableInstances.push(draggable);
    };

    window.createCustom = function () {
      clearAll();
      const glass = new LiquidGlassCore({
        size: { width: 400, height: 250 },
        position: { x: window.innerWidth / 2 - 200, y: window.innerHeight / 2 - 125 },
        effects: {
          displacementScale: 1.5,
          blurAmount: 0.75,
          saturation: 1.5,
          chromaticAberration: 0.2,
          elasticity: 1.2,
          cornerRadius: 20
        },
        style: {
          borderRadius: "20px",
          boxShadow: "0 8px 32px rgba(100, 255, 218, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(0.5px) brightness(1.2) saturate(1.5)",
          cursor: "grab",
          zIndex: 9999
        }
      });
      glass.init();
      glass.appendTo(document.body);


      // Add custom drag behavior
      const draggable = new LiquidGlassDraggable(glass, {
        constrainToViewport: false, // Allow dragging outside screen
        onDragStart: (position) => {
          // 保持原始样式，不添加任何视觉效果
        },
        onDrag: (position) => {
          // 保持原始样式和效果，不进行动态调整
        },
        onDragEnd: (position) => {
          // If dragged to screen edge, bounce back to viewport
          const bounds = glass.getBounds();
          if (bounds) {
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            if (bounds.x < 0 || bounds.x + bounds.width > viewportWidth ||
              bounds.y < 0 || bounds.y + bounds.height > viewportHeight) {

              const constrainedPosition = glass.constrainPosition(position.x, position.y);

              // Add elastic animation
              const container = glass.getContainer();
              if (container) {
                container.style.transition = 'all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)';
                glass.setPosition(constrainedPosition);

                setTimeout(() => {
                  container.style.transition = '';
                }, 500);
              }
            }
          }
        }
      });

      window.liquidGlassInstances.push(glass);
      window.draggableInstances.push(draggable);
    };

    // Performance optimization: throttle function
    function throttle(func, limit) {
      let inThrottle;
      return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      }
    }

    // Store default effects for each instance
    window.instanceDefaultEffects = new Map();

    window.createMultiple = function () {
      clearAll();
      window.instanceDefaultEffects.clear();

      for (let i = 0; i < 3; i++) {
        const defaultEffects = {
          displacementScale: 1.0 + i * 0.3,
          blurAmount: 0.2 + i * 0.1,
          saturation: 1.0 + i * 0.2,
          chromaticAberration: i * 0.1,
          cornerRadius: 30 + i * 10,
          elasticity: 1.0 + i * 0.5
        };

        const glass = new LiquidGlassCore({
          size: { width: 200 + i * 30, height: 150 + i * 20 },
          position: { x: 100 + i * 150, y: 100 + i * 80 },
          effects: defaultEffects,
          style: {
            borderRadius: `${30 + i * 10}px`,
            boxShadow: `0 4px 16px rgba(${100 + i * 50}, ${255 - i * 50}, ${200 + i * 20}, 0.4)`,
            backdropFilter: `blur(${0.3 + i * 0.2}px) brightness(${1.3 + i * 0.2}) saturate(${1.2 + i * 0.3})`,
            cursor: "grab",
            zIndex: 9999 + i
          }
        });

        glass.init();
        glass.appendTo(document.body);

        // Store default effects
        window.instanceDefaultEffects.set(glass, defaultEffects);

        // Create throttled cooperative effect update function
        const throttledCooperativeUpdate = throttle((position) => {
          // Batch calculate all influences
          const updates = [];

          window.liquidGlassInstances.forEach((otherGlass, otherIndex) => {
            if (otherGlass !== glass) {
              const otherPos = otherGlass.getPosition();
              const distance = Math.sqrt(
                Math.pow(position.x - otherPos.x, 2) +
                Math.pow(position.y - otherPos.y, 2)
              );

              // Only update within influence range
              const influence = Math.max(0, 1 - distance / 300);
              if (influence > 0.05) { // Threshold filtering to avoid minor changes
                const defaultEffects = window.instanceDefaultEffects.get(otherGlass);
                updates.push({
                  glass: otherGlass,
                  effects: {
                    displacementScale: defaultEffects.displacementScale + influence * 0.5,
                    blurAmount: defaultEffects.blurAmount + influence * 0.3,
                    saturation: defaultEffects.saturation + influence * 0.4
                  }
                });
              }
            }
          });

          // Batch apply updates
          updates.forEach(update => {
            update.glass.updateEffects(update.effects);
          });
        }, 16); // About 60fps update frequency

        // Add optimized cooperative drag functionality for each instance
        const draggable = new LiquidGlassDraggable(glass, {
          constrainToViewport: true,
          onDragStart: (position) => {
            // 保持原始样式，不添加任何视觉效果
          },
          onDrag: (position) => {
            // 保持原始样式，不进行协作效果更新
          },
          onDragEnd: (position) => {
            // 保持原始样式，不修改任何效果
          }
        });

        window.liquidGlassInstances.push(glass);
        window.draggableInstances.push(draggable);
      }
    };

    // Programmatic position control example
    window.createProgrammatic = function () {
      clearAll();
      const glass = new LiquidGlassCore({
        size: { width: 180, height: 100 },
        position: { x: 50, y: 50 },
        effects: {
          displacementScale: 1.2,
          blurAmount: 0.65,
          saturation: 1.3,
          chromaticAberration: 0.0,
          elasticity: 2.0,
          cornerRadius: 50
        }
      });

      glass.init();
      glass.appendTo(document.body);

      // No drag functionality, completely controlled by program
      window.liquidGlassInstances.push(glass);

      // Automatic movement animation
      let angle = 0;
      const centerX = window.innerWidth / 2 - 90;
      const centerY = window.innerHeight / 2 - 50;
      const radius = 100;

      const animate = () => {
        angle += 0.02;
        const x = centerX + Math.cos(angle) * radius;
        const y = centerY + Math.sin(angle) * radius;

        glass.setPosition({ x, y });

        // Dynamically adjust effects based on position
        const normalizedAngle = (angle % (Math.PI * 2)) / (Math.PI * 2);
        glass.updateEffects({
          chromaticAberration: normalizedAngle * 2,
          cornerRadius: 50 + normalizedAngle * 100,
          saturation: 1.0 + normalizedAngle * 0.5
        });

        requestAnimationFrame(animate);
      };

      animate();
    };

    window.changeSize = function (size) {
      const dimensions = {
        small: { width: 200, height: 120 },
        medium: { width: 300, height: 200 },
        large: { width: 450, height: 300 }
      };

      window.liquidGlassInstances.forEach(glass => {
        glass.setSize(dimensions[size]);
      });
    };

    window.changeTheme = function (theme) {
      const themes = {
        glass: {
          borderRadius: "50px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.25), 0 -10px 25px inset rgba(0, 0, 0, 0.15), 0 -1px 4px 1px inset rgba(255, 255, 255, 0.74)",
          backdropFilter: "blur(0.25px) brightness(1.5) saturate(1.1)",
          cursor: "grab",
          zIndex: 9999
        },
        neon: {
          borderRadius: "15px",
          boxShadow: "0 0 30px rgba(64, 255, 218, 0.6), 0 0 60px rgba(64, 255, 218, 0.3)",
          backdropFilter: "blur(0.5px) brightness(1.8) saturate(2.0) hue-rotate(180deg)",
          cursor: "grab",
          zIndex: 9999
        },
        fire: {
          borderRadius: "80px",
          boxShadow: "0 0 40px rgba(255, 69, 0, 0.8), 0 0 80px rgba(255, 140, 0, 0.4)",
          backdropFilter: "blur(0.3px) brightness(2.0) saturate(2.5) hue-rotate(30deg)",
          cursor: "grab",
          zIndex: 9999
        },
        ice: {
          borderRadius: "100px",
          boxShadow: "0 0 25px rgba(173, 216, 230, 0.7), 0 0 50px rgba(135, 206, 250, 0.4)",
          backdropFilter: "blur(0.4px) brightness(1.3) saturate(0.8) hue-rotate(200deg)",
          cursor: "grab",
          zIndex: 9999
        }
      };

      window.liquidGlassInstances.forEach(glass => {
        glass.updateConfig({ style: themes[theme] });
      });
    };

    window.animatePosition = function () {
      window.liquidGlassInstances.forEach((glass, index) => {
        let step = 0;
        const startX = Math.random() * (window.innerWidth - 300);
        const startY = Math.random() * (window.innerHeight - 200);

        const animate = () => {
          if (step < 100) {
            const progress = step / 100;
            const x = startX + Math.sin(progress * Math.PI * 4 + index) * 100;
            const y = startY + Math.cos(progress * Math.PI * 3 + index) * 50;
            glass.setPosition({ x, y });
            step++;
            requestAnimationFrame(animate);
          }
        };

        setTimeout(() => animate(), index * 200);
      });
    };

    window.animateSize = function () {
      window.liquidGlassInstances.forEach((glass, index) => {
        let step = 0;
        const baseWidth = 250;
        const baseHeight = 180;

        const animate = () => {
          if (step < 120) {
            const progress = step / 120;
            const scale = 1 + Math.sin(progress * Math.PI * 2) * 0.3;
            glass.setSize({
              width: baseWidth * scale,
              height: baseHeight * scale
            });
            step++;
            requestAnimationFrame(animate);
          } else {
            glass.setSize({ width: baseWidth, height: baseHeight });
          }
        };

        setTimeout(() => animate(), index * 300);
      });
    };

    window.clearAll = function () {
      // Destroy all draggable instances
      window.draggableInstances.forEach(draggable => draggable.destroy());
      window.draggableInstances = [];

      // Destroy all liquid glass instances
      window.liquidGlassInstances.forEach(glass => glass.destroy());
      window.liquidGlassInstances = [];

      // Clean up performance optimization related data
      if (window.instanceDefaultEffects) {
        window.instanceDefaultEffects.clear();
      }
    };

    // Effect control related functions
    window.showEffectControls = function () {
      document.getElementById('effectsPanel').style.display = 'block';
    };

    window.hideEffectControls = function () {
      document.getElementById('effectsPanel').style.display = 'none';
    };

    window.updateEffect = function (effectName, value) {
      const numValue = parseFloat(value);

      // Update display value
      document.getElementById(effectName + 'Value').textContent = value;

      // Update effects for all instances
      window.liquidGlassInstances.forEach(glass => {
        const effects = {};
        effects[effectName] = numValue;
        glass.updateEffects(effects);
      });
    };

    window.resetEffects = function () {
      const defaultEffects = {
        displacementScale: 1.0,
        blurAmount: 0.65,
        saturation: 1.1,
        chromaticAberration: 0.0,
        elasticity: 1.0,
        cornerRadius: 50
      };

      // Reset slider values
      Object.keys(defaultEffects).forEach(key => {
        const slider = document.getElementById(key);
        const valueSpan = document.getElementById(key + 'Value');
        if (slider && valueSpan) {
          slider.value = defaultEffects[key];
          valueSpan.textContent = defaultEffects[key];
        }
      });

      // Update all instances
      window.liquidGlassInstances.forEach(glass => {
        glass.updateEffects(defaultEffects);
      });
    };

    // Performance monitoring related
    let performanceMonitorVisible = false;
    let fpsCounter = 0;
    let lastFpsTime = performance.now();
    let frameCount = 0;

    function updatePerformanceMonitor() {
      if (!performanceMonitorVisible) return;

      frameCount++;
      const now = performance.now();

      if (now - lastFpsTime >= 1000) {
        fpsCounter = Math.round((frameCount * 1000) / (now - lastFpsTime));
        frameCount = 0;
        lastFpsTime = now;

        document.getElementById('fpsCounter').textContent = fpsCounter;
      }

      document.getElementById('instanceCount').textContent = window.liquidGlassInstances.length;

      const draggingCount = window.draggableInstances.filter(d => d.isDragginActive && d.isDragginActive()).length;
      document.getElementById('dragStatus').textContent = draggingCount > 0 ? `${draggingCount} dragging` : 'None';

      requestAnimationFrame(updatePerformanceMonitor);
    }

    window.togglePerformanceMonitor = function () {
      const monitor = document.getElementById('performanceMonitor');
      performanceMonitorVisible = !performanceMonitorVisible;

      if (performanceMonitorVisible) {
        monitor.style.display = 'block';
        updatePerformanceMonitor();
      } else {
        monitor.style.display = 'none';
      }
    };

    // Add keyboard shortcuts
    document.addEventListener('keydown', (e) => {
      // Skip if modifier keys are pressed (handled by control panel shortcuts)
      if (e.ctrlKey || e.metaKey) return;

      if (e.key === 'Escape') {
        hideEffectControls();
      } else if (e.key === 'e' || e.key === 'E') {
        const panel = document.getElementById('effectsPanel');
        if (panel.style.display === 'none' || !panel.style.display) {
          showEffectControls();
        } else {
          hideEffectControls();
        }
      } else if (e.key === 'p' || e.key === 'P') {
        togglePerformanceMonitor();
      }
    });

    // Scroll indicator functionality
    function handleScrollIndicator() {
      const scrollIndicator = document.querySelector('.scroll-indicator');
      const imageGallery = document.querySelector('.image-gallery');

      if (!scrollIndicator || !imageGallery) return;

      const handleScroll = () => {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;

        // Hide indicator when user starts scrolling or reaches gallery
        if (scrollY > viewportHeight * 0.1) {
          scrollIndicator.style.opacity = '0';
          scrollIndicator.style.pointerEvents = 'none';
        } else {
          scrollIndicator.style.opacity = '1';
          scrollIndicator.style.pointerEvents = 'auto';
        }
      };

      // Smooth scroll to gallery when indicator is clicked
      scrollIndicator.addEventListener('click', () => {
        imageGallery.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Initial call
    }

    // Enhanced image loading with error handling and retry mechanism
    function enhanceImageLoading() {
      const images = document.querySelectorAll('.image-item img');

      images.forEach((img, index) => {
        const imageItem = img.closest('.image-item');

        // Add loading state
        imageItem.style.opacity = '0';
        imageItem.style.transform = 'translateY(20px)';
        imageItem.style.transition = 'opacity 0.6s ease, transform 0.6s ease';

        // Add loading indicator
        addLoadingIndicator(imageItem);

        // Load image immediately (no lazy loading)
        loadImageWithRetry(img, imageItem);
      });
    }

    // Add loading indicator to image item
    function addLoadingIndicator(imageItem) {
      const loadingDiv = document.createElement('div');
      loadingDiv.className = 'image-loading';
      loadingDiv.innerHTML = `
        <div class="loading-spinner"></div>
        <div class="loading-text">Loading...</div>
      `;
      imageItem.appendChild(loadingDiv);
    }

    // Load image with retry mechanism
    function loadImageWithRetry(img, imageItem, retryCount = 0) {
      const maxRetries = 3;
      const src = img.src; // Use the original src directly

      const newImg = new Image();

      newImg.onload = function () {
        // Image loaded successfully
        imageItem.style.opacity = '1';
        imageItem.style.transform = 'translateY(0)';

        // Remove loading indicator
        const loadingIndicator = imageItem.querySelector('.image-loading');
        if (loadingIndicator) {
          loadingIndicator.remove();
        }
      };

      newImg.onerror = function () {
        if (retryCount < maxRetries) {
          console.log(`Retrying image load (${retryCount + 1}/${maxRetries}):`, src);
          setTimeout(() => {
            loadImageWithRetry(img, imageItem, retryCount + 1);
          }, 1000 * (retryCount + 1)); // Exponential backoff
        } else {
          console.error('Failed to load image after', maxRetries, 'attempts:', src);
          showImageError(imageItem, src);
        }
      };

      // Set a timeout for loading
      setTimeout(() => {
        if (!newImg.complete) {
          newImg.src = ''; // Cancel loading
          if (retryCount < maxRetries) {
            loadImageWithRetry(img, imageItem, retryCount + 1);
          }
        }
      }, 10000); // 10 second timeout

      newImg.src = src;
    }

    // Show error state for failed images
    function showImageError(imageItem, src) {
      const loadingIndicator = imageItem.querySelector('.image-loading');
      if (loadingIndicator) {
        loadingIndicator.innerHTML = `
          <div class="error-icon">⚠️</div>
          <div class="error-text">Failed to load image</div>
          <button class="retry-btn" onclick="retryImageLoad(this, '${src}')">Retry</button>
        `;
        loadingIndicator.className = 'image-error';
      }
    }

    // Retry failed image loading
    window.retryImageLoad = function (button, src) {
      const imageItem = button.closest('.image-item');
      const img = imageItem.querySelector('img');

      // Reset to loading state
      const errorDiv = imageItem.querySelector('.image-error');
      if (errorDiv) {
        errorDiv.className = 'image-loading';
        errorDiv.innerHTML = `
          <div class="loading-spinner"></div>
          <div class="loading-text">Retrying...</div>
        `;
      }

      // Retry loading
      img.src = src;
      loadImageWithRetry(img, imageItem);
    };

    // Control panel minimize/maximize functionality
    let isControlPanelMinimized = false;

    window.toggleControlPanel = function () {
      const controlPanel = document.getElementById('controlPanel');
      const minimizeIcon = document.getElementById('minimizeIcon');

      if (!controlPanel || !minimizeIcon) return;

      isControlPanelMinimized = !isControlPanelMinimized;

      if (isControlPanelMinimized) {
        controlPanel.classList.add('minimized');
        minimizeIcon.textContent = '+';
        minimizeIcon.parentElement.title = 'Maximize Control Panel';
      } else {
        controlPanel.classList.remove('minimized');
        minimizeIcon.textContent = '−';
        minimizeIcon.parentElement.title = 'Minimize Control Panel';
      }
    };

    // Add keyboard shortcut for control panel toggle
    function addControlPanelShortcuts() {
      document.addEventListener('keydown', (e) => {
        // Toggle control panel with Ctrl/Cmd + M
        if ((e.ctrlKey || e.metaKey) && e.key === 'm') {
          e.preventDefault();
          toggleControlPanel();
        }
      });
    }

    // Initially create a basic instance
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        createBasic();
      }, 1000);

      // Initialize image gallery features
      handleScrollIndicator();
      enhanceImageLoading();

      // Initialize control panel features
      addControlPanelShortcuts();
    });
  